export const REFERRAL_TABS = {
  SHARE: "share",
  MY_REFERRALS: "my-referrals",
} as const;

export const WORKER_REFERRALS_PATH = "worker-referrals";
export const WORKER_REFERRALS_PATH_FULL = `/home-v2/${WORKER_REFERRALS_PATH}`;
export const WORKER_REFERRALS_SHARE_LINK_PATH = `${WORKER_REFERRALS_PATH}?tab=${REFERRAL_TABS.SHARE}`;
export const WORKER_REFERRALS_SHARE_LINK_PATH_FULL = `/home-v2/${WORKER_REFERRALS_SHARE_LINK_PATH}`;

export const WORKER_REFERRALS_MY_REFERRALS_PATH = `${WORKER_REFERRALS_PATH}?tab=${REFERRAL_TABS.MY_REFERRALS}`;
export const WORKER_REFERRALS_MY_REFERRALS_PATH_FULL = `/home-v2/${WORKER_REFERRALS_MY_REFERRALS_PATH}`;

// These paths have been renamed to the above paths
export const REFERRAL_SHARE_LINK_PATH = "referral/share-link";
export const REFERRAL_SHARE_LINK_PATH_FULL = `/home-v2/${REFERRAL_SHARE_LINK_PATH}`;
